import { render, staticRenderFns } from "./foom.vue?vue&type=template&id=6b075d0c&scoped=true&"
import script from "./foom.vue?vue&type=script&setup=true&lang=ts&"
export * from "./foom.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./foom.vue?vue&type=style&index=0&id=6b075d0c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b075d0c",
  null
  
)

export default component.exports